import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, AfterViewChecked, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'tidy-dashboard-chat',
  templateUrl: './dashboard-chat.component.html',
  styleUrls: ['./dashboard-chat.component.scss'],
  standalone: false
})
export class DashboardChatComponent implements OnInit, AfterViewChecked, OnChanges {
  @Input() propertySummary = '';
  @Output() messageSent = new EventEmitter<string>();
  @ViewChild('messageInput') messageInput: ElementRef;

  chatForm: UntypedFormGroup;
  isRespondingFromLLM = false;
  isTyping = false;
  chatMessages: string[] = [];
  showChatPanel = true;
  private chatMessagesContainer: HTMLElement;

  constructor(private fb: UntypedFormBuilder, private cdr: ChangeDetectorRef) {
    this.chatForm = this.fb.group({
      message: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.initializeDefaultMessage();
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['propertySummary'] && this.propertySummary) {
      this.chatMessages = [this.propertySummary];
    }
  }

  private initializeDefaultMessage(): void {
    const defaultSummary = 'Good morning! Here\'s your daily summary: You have 5 jobs scheduled today, 2 unread messages, and $1,240 in pending invoices. Everything is running smoothly!';
    this.chatMessages = [defaultSummary];
  }

  sendMessage(): void {
    if (this.chatForm.valid && !this.isRespondingFromLLM) {
      const message = this.chatForm.get('message').value.trim();
      if (message) {
        this.messageSent.emit(message);
        this.chatForm.reset();
        this.showLLMResponse();
      }
    }
  }

  private showLLMResponse(): void {
    this.isRespondingFromLLM = true;
    this.isTyping = true;

    const sampleResponse = 'I can help you manage your dashboard. You can ask me about your schedules, messages, invoices, or any other information you need.';
    let currentIndex = 0;
    const messageIndex = this.chatMessages.length;
    this.chatMessages.push('');

    const typingInterval = setInterval(() => {
      if (currentIndex < sampleResponse.length) {
        this.chatMessages[messageIndex] += sampleResponse[currentIndex];
        this.cdr.markForCheck();
        currentIndex++;
      } else {
        this.isTyping = false;
        this.isRespondingFromLLM = false;
        this.cdr.markForCheck();
        clearInterval(typingInterval);
      }
    }, 30);
  }

  private scrollToBottom(): void {
    try {
      const container = document.querySelector('.chat-messages');
      if (container) {
        setTimeout(() => {
          container.scrollTop = container.scrollHeight;
        }, 0);
      }
    } catch (err) {
      console.error('Error scrolling to bottom:', err);
    }
  }

  onMessageInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  onContainerClick(event: MouseEvent): void {
    if (!this.showChatPanel) {
      return;
    }

    const chatBarWrapper = (event.currentTarget as HTMLElement).querySelector('.chat-bar-wrapper');
    const isClickOnInput = chatBarWrapper?.contains(event.target as Node);

    if (!isClickOnInput) {
      this.showChatPanel = false;
    }
  }
}
